/** Salut table sort field for profile/contact updated time */
export const SORT_KEY_UPDATED_AT_T = 'updatedAt.{t}';

/** Payment-style tables: date then updated */
export const SORT_KEY_TRANSACTION_DATE_T = 'transactionDate.{t}';

/**
 * Appends `updatedAt.{t}` as a sort tiebreaker when not already in `sortBy`.
 * Keeps `sortDesc` aligned (one `tiebreakerDesc` per appended key).
 */
export function appendUpdatedAtTiebreaker(
	sortBy: string[] | undefined,
	sortDesc: boolean[] | undefined,
	tiebreakerDesc = true,
): { sortBy: string[]; sortDesc: boolean[] } {
	const sb = [...(sortBy ?? [])];
	const sd = [...(sortDesc ?? [])];
	if (!sb.includes(SORT_KEY_UPDATED_AT_T)) {
		sb.push(SORT_KEY_UPDATED_AT_T);
		sd.push(tiebreakerDesc);
	}
	return { sortBy: sb, sortDesc: sd };
}

/**
 * Appends `transactionDate.{t}` then `updatedAt.{t}` when missing (payment / cash tables).
 */
export function appendPaymentTableSortTiebreakers(
	sortBy: string[] | undefined,
	sortDesc: boolean[] | undefined,
): { sortBy: string[]; sortDesc: boolean[] } {
	const sb = [...(sortBy ?? [])];
	const sd = [...(sortDesc ?? [])];
	if (!sb.includes(SORT_KEY_TRANSACTION_DATE_T)) {
		sb.push(SORT_KEY_TRANSACTION_DATE_T);
		sd.push(true);
	}
	if (!sb.includes(SORT_KEY_UPDATED_AT_T)) {
		sb.push(SORT_KEY_UPDATED_AT_T);
		sd.push(true);
	}
	return { sortBy: sb, sortDesc: sd };
}
